<template>
  <div>
    <Banner bgsrc="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/product/product_banner.png">
      <div class="w-product_banner">
        <span class="w-banner_text">{{ this.$t('product.productTitle') }}</span>
        <span class="w-button_text">{{ this.$t('product.productText') }}</span>
      </div>
    </Banner>
    <div class="w-product_reasons">
      <XYTitle xText="REASONS"></XYTitle>
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-reasons_text">
          <span class="w-moduleBanner_text">{{ this.$t('product.reasonsTitle') }}</span>
          <span class="w-text_choose">WHY CHOOSE US</span>
        </div>
      </Animation>
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-reasons_list">
          <div>
            <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
              <div class="w-img_box">
                <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/product/product_img_1.png" alt="" />
              </div>
            </Animation>
            <Animation defaultClass="w-transform_top2" animationClass="w-transform_show">
              <div class="w-text_box">
                <span class="w-button_text">{{ this.$t('product.reasonsText1') }}</span>
              </div>
            </Animation>
          </div>
          <div>
            <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
              <div class="w-img_box">
                <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/product/product_img_2.png" alt="" />
              </div>
            </Animation>
            <Animation defaultClass="w-transform_top2" animationClass="w-transform_show">
              <div class="w-text_box">
                <span class="w-button_text">{{ this.$t('product.reasonsText2') }}</span>
              </div>
            </Animation>
          </div>
          <div>
            <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
              <div class="w-img_box">
                <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/product/product_img_3.png" alt="" />
              </div>
            </Animation>
            <Animation defaultClass="w-transform_top2" animationClass="w-transform_show">
              <div class="w-text_box">
                <span class="w-button_text">{{ this.$t('product.reasonsText3') }}</span>
              </div>
            </Animation>
          </div>
          <div>
            <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
              <div class="w-img_box">
                <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/product/product_img_4.png" alt="" />
              </div>
            </Animation>
            <Animation defaultClass="w-transform_top2" animationClass="w-transform_show">
              <div class="w-text_box">
                <span class="w-button_text">{{ this.$t('product.reasonsText4') }}</span>
              </div>
            </Animation>
          </div>
        </div>
      </Animation>
    </div>
    <div class="w-product_products">
      <div class="w_xyTitle">
        <XYTitle xText="PRODUCTS"></XYTitle>
      </div>
      <div class="w-btn_list">
        <div :class="['w-item', isActive == 1 ? 'w-item_active' : '']" @click="handProducts(1)">
          <span class="w-active_text">D9X {{ this.$t('productDetail.series') }}</span>
        </div>
        <div :class="['w-item', isActive == 2 ? 'w-item_active' : '']" @click="handProducts(2)">
          <span class="w-active_text">D8X {{ this.$t('productDetail.series') }}</span>
        </div>
        <div :class="['w-item', isActive == 3 ? 'w-item_active' : '']" @click="handProducts(3)">
          <span class="w-active_text">D6X {{ this.$t('productDetail.series') }}</span>
        </div>
        <div :class="['w-item', isActive == 4 ? 'w-item_active' : '']" @click="handProducts(4)">
          <span class="w-active_text">{{ this.$t('home.productBlueTooth') }}</span>
        </div>
      </div>
      <div class="w-products_list">
        <div class="w-list_box1 w-product_hover">
          <div v-for="(item, index) in productList" :key="index" class="hover_box" @click="handProduct(item.productName)">
            <img :src="item.src" alt="" />
            <div>
              <div class="w-hover_move">
                <span class="w-moduleBanner_text w_xuyu">{{ item.productName }}</span>
                <div class="w_aboutUsMore w-transform_timing">
                  <span class="w-button_text">{{item.viewMore}}</span>
                  <i class="iconfont icon-common_icon_more w-button_text"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Banner from '@/components/Banner'
import XYTitle from '@/components/XYTitle.vue'
import Animation from '@/components/Animation.vue'
import Footer from '@/components/Footer.vue'

export default {
  props: {},
  data () {
    return {
      isActive: 1
    }
  },
  computed: {
    productList () {
      let obj = []
      if (this.isActive == 1)      {
        obj = [
          {
            id: 1,
            src: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product1.png',
            productName: 'D98',
            viewMore: this.$t('home.viewMore')
          },
          {
            id: 1,
            src: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product2.png',
            productName: 'D96',
            viewMore: this.$t('home.viewMore')
          },
          {
            id: 1,
            src: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product3.png',
            productName: 'D92',
            viewMore: this.$t('home.viewMore')
          }
        ]
      } else if (this.isActive == 2)      {
        obj = [
          {
            id: 1,
            src: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product4.png',
            productName: 'D82',
            viewMore: this.$t('home.viewMore')
          }
        ]
      } else if (this.isActive == 3)      {
        obj = [
          {
            id: 1,
            src: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product5.png',
            productName: 'D60',
            viewMore: this.$t('home.viewMore')
          }
        ]
      } else if (this.isActive == 4)      {
        obj = [
          {
            id: 1,
            src: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product6.png',
            productName: this.$t('home.productBlueTooth'),
            viewMore: this.$t('home.viewMore')
          }
        ]
      } else      {
        obj = []
      }
      return obj
    }
  },
  methods: {
    handProducts (data) {
      //切换产品类型
      this.isActive = data
    },
    handProduct (data) {
      //点击产品
      this.$emit('openProdect', { activeId: 2, menuName: 'ProductDetail', prodectId: data })
    }
  },
  components: { XYTitle, Banner, Animation, Footer }
}
</script>

<style scoped lang="scss">
.w-product_banner {
  display: flex;
  flex-direction: column;
  color: rgba(0, 0, 0, 0.85);
  .w-banner_text {
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 16px;
  }
}
</style>
